// extracted by mini-css-extract-plugin
export var deleteModal = "_s2-0";